import { Component } from '@angular/core';

@Component({
    selector: 'app-security-question-answer-not-match',
    templateUrl: './security-question-answer-not-match.component.html',
    standalone: false
})
export class SecurityQuestionAnswerNotMatchComponent {
  constructor() {}
}
